module.exports = __webpack_public_path__ + "img/mc-yy-on.d9f4b053.gif";